import { router } from '@inertiajs/react'

export function useOrderActions(orderId: number, organizationSlug: string) {
  const orderPath = `/organizations/${organizationSlug}/orders/${orderId}`

  const confirmReception = () => router.post(`${orderPath}/reception`, {}, { preserveScroll: true })

  const markCompleted = () => router.post(`${orderPath}/completion`, {}, { preserveScroll: true })

  const markDelivered = () => router.post(`${orderPath}/delivery`, {}, { preserveScroll: true })

  const handleSendSms = () =>
    router.post(`/organizations/${organizationSlug}/notifications`, { order_ids: [orderId] }, { preserveScroll: true })

  const handlePayment = (paymentMethod: 'cash' | 'card', collectAfter: boolean = false) =>
    router.post(
      `${orderPath}/payment`,
      { payment_method: paymentMethod },
      collectAfter ? { preserveScroll: true, onSuccess: () => markCompleted() } : { preserveScroll: true }
    )

  const handleDeleteOrder = () => {
    if (!confirm('Êtes-vous sûr de vouloir supprimer cette commande ?')) return
    router.delete(orderPath)
  }

  return { confirmReception, markCompleted, markDelivered, handleSendSms, handlePayment, handleDeleteOrder }
}
